import React from "react";
import { connect } from "react-redux";
import resolveModel from "react-redux-form/lib/utils/resolve-model";
import { compose } from "recompose";
import { Control, actions } from "react-redux-form";

export const NumberField = ({ dispatch, ...props }) => (
  <Control.text
    type="number"
    step="0.01"
    changeAction={(m, v) => {
      dispatch(actions.change(m, `${v}` ? v : undefined));
    }}
    {...props}
  />
);

export const enhance = compose(
  resolveModel,
  connect(null, (dispatch, ownProps) => ({
    dispatch: ownProps.dispatch || dispatch,
  }))
);

export default enhance(NumberField);
